document.addEventListener("alpine:init", () => {
    Alpine.data("Footer", () => ({
        openAccordion: null,
    }));
});
